import { graphql } from "gatsby";
import React, { Component } from "react";

import FreeFormPage from "./freeform-page";

export default class PublicPage extends Component {
    render(): JSX.Element {
        return <FreeFormPage {...this.props} />;
    }
}
// Note: any extended part of the query (e.g. ...bodyFields)
// is imported by gatsby itself from the various fragments found in the fragments folder
export const query = graphql`
    query ($id: String!, $locale: String!) {
        page: contentstackPage(id: { eq: $id }) {
            title
            uid
            title
            page_title
            table_of_content
            url
            updated_at
            imedical_review {
                imr {
                    code: title
                    date_of_preparation
                }
            }
            ...bodyFields
            seo_settings {
                meta_title
                page_description
                canonical_tag
                hreflang_associated_url
                indexing_and_sitemap
                paywall
                paywall_teaser {
                    title
                    ...fragmentFields
                }
                teaser_imr_code {
                    imr {
                        code: title
                        date_of_preparation
                    }
                }
                twitter {
                    title
                    description
                    image {
                        url
                    }
                }
                open_graph {
                    title
                    description
                    image {
                        url
                    }
                }
                medical_expert_reviewer
                medical_expert {
                    prefix
                    first_name
                    last_name
                    title
                    job_title
                    linkedin_profile
                    avatar_image {
                        url
                    }
                    related_to {
                        ... on Contentstack_specialty {
                            specialtyTitle: title
                        }
                    }
                }
            }
            regulatory_status {
                promotional_or_medical
            }
            access_control {
                access_level
            }
            header_visual {
                header_visual_source
                header_image_size
                header_image_from_file {
                    url
                    gatsbyImageData(layout: FULL_WIDTH)
                }
                image_focus {
                    image_focus
                }
                select_hero {
                    ...heroFields
                }
                select_carousel {
                    ...carouselFields
                }
                variant
                background_color
            }
            maintenance_mode {
                temporary_maintenance_mode
                maintenance_fragment {
                    ...fragmentFields
                }
            }
            site_reference {
                maintenance_mode {
                    temporary_maintenance_mode
                    maintenance_fragment {
                        ...fragmentFields
                    }
                }
                meta_fields {
                    title_suffix
                    site_description
                    paywall
                    site_paywall_teaser {
                        title
                        ...fragmentFields
                    }
                    site_teaser_imr {
                        imr {
                            code: title
                            date_of_preparation
                        }
                    }
                    medical_expert {
                        prefix
                        first_name
                        last_name
                        job_title
                        title
                        linkedin_profile
                        avatar_image {
                            url
                        }
                        related_to {
                            ... on Contentstack_specialty {
                                specialtyTitle: title
                            }
                        }
                    }
                }
                imedical_review {
                    imr {
                        code: title
                        date_of_preparation
                    }
                }
                ae_pi_disclaimer
                branding {
                    header_visual {
                        url
                        gatsbyImageData(layout: FULL_WIDTH)
                    }
                    logo {
                        url
                        gatsbyImageData(layout: FULL_WIDTH)
                    }
                    image_focus {
                        image_focus
                    }
                }
                startpage {
                    uid
                    url
                    access_control {
                        access_level
                    }
                }
                relation {
                    __typename
                    ... on Contentstack_product {
                        uid
                        productTitle: title
                        active_ingredient
                        pharmacovigiliance
                        productLogo: logo {
                            url
                            gatsbyImageData(layout: FULL_WIDTH)
                        }
                    }
                    ... on Contentstack_specialty {
                        specialtyTitle: title
                        specialtyLogo: logo {
                            url
                            gatsbyImageData(layout: FULL_WIDTH)
                        }
                    }
                    ... on Contentstack_event {
                        eventTitle: title
                        visual {
                            url
                            gatsbyImageData(layout: FULL_WIDTH)
                        }
                    }
                }
                site_menu {
                    submenu {
                        menu_label
                        link {
                            internal_page_link {
                                internal_link_anchor_id
                                internal_link_parameters
                                visibility
                                link {
                                    ... on Contentstack_page {
                                        page_url: url
                                        access_control {
                                            access_level
                                        }
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                    }
                                    ... on Contentstack_request_materials {
                                        request_materials_uid: uid
                                    }
                                    ... on Contentstack_media_center {
                                        media_center_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_service_overview {
                                        service_overview_uid: uid
                                    }
                                    ... on Contentstack_news_center {
                                        news_center_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_ask_the_experts {
                                        ask_the_experts_uid: uid
                                    }
                                    ... on Contentstack_drug_to_drug {
                                        drug_to_drug_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_learning_center {
                                        lms_uid: uid
                                    }
                                    ... on Contentstack_transfer_of_value {
                                        transfer_of_value_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_event_center {
                                        event_center_uid: uid
                                    }
                                    ... on Contentstack_external_resource {
                                        external_resource_url: url {
                                            href
                                        }
                                    }
                                    ... on Contentstack_material {
                                        material_id: uid
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_article {
                                        article_id: uid
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_video {
                                        video_id
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_audio {
                                        audio_id
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_event {
                                        event_id: iconnect_event_number
                                    }
                                    ... on Contentstack_product_glossary {
                                        product_glossary: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_myjmc {
                                        myjmc_id: id
                                    }
                                    ... on Contentstack_podcast {
                                        podcast_title: title
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_tcp_home {
                                        page_url: url
                                    }
                                    ... on Contentstack_information_on_demand {
                                        iod_id: uid
                                    }
                                    ... on Contentstack_course {
                                        course_id: moodle_course_number
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                    }
                                    ... on Contentstack_scientific_publications {
                                        scientific_publications_uid: uid
                                    }
                                    ... on Contentstack_scientific_publication {
                                        sp_detail_id: uid
                                    }
                                    ... on Contentstack_pubmed {
                                        pubmed_id: id
                                        access_control {
                                            access_level
                                        }
                                    }
                                }
                            }
                            external_link {
                                link {
                                    href
                                }
                            }
                            file_asset {
                                file_asset_upload {
                                    url: transformedUrl
                                }
                                visibility
                            }
                        }
                        menu_item {
                            internal_page_link {
                                menu_label
                                anchor_id
                                link {
                                    ... on Contentstack_page {
                                        page_url: url
                                        access_control {
                                            access_level
                                        }
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                    }
                                    ... on Contentstack_request_materials {
                                        request_materials_uid: uid
                                    }
                                    ... on Contentstack_media_center {
                                        media_center_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_service_overview {
                                        service_overview_uid: uid
                                    }
                                    ... on Contentstack_news_center {
                                        news_center_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_podcast_center {
                                        podcast_center_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_specialties {
                                        specialties_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_transfer_of_value {
                                        transfer_of_value_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_event_center {
                                        event_center_uid: uid
                                    }
                                    ... on Contentstack_external_resource {
                                        external_resource_url: url {
                                            href
                                        }
                                    }
                                    ... on Contentstack_material {
                                        material_id: uid
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_article {
                                        article_id: uid
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_video {
                                        video_id
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_audio {
                                        audio_id
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_podcast {
                                        podcast_title: title
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_tcp_home {
                                        page_url: url
                                    }
                                    ... on Contentstack_event {
                                        event_id: iconnect_event_number
                                    }
                                    ... on Contentstack_pubmed {
                                        pubmed_id: id
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_product_glossary {
                                        product_glossary: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_myjmc {
                                        myjmc_id: id
                                    }
                                    ... on Contentstack_information_on_demand {
                                        iod_id: uid
                                    }
                                    ... on Contentstack_ask_the_experts {
                                        ask_the_experts_uid: uid
                                    }
                                    ... on Contentstack_drug_to_drug {
                                        drug_to_drug_uid: uid
                                        access_control {
                                            access_level
                                        }
                                    }
                                    ... on Contentstack_learning_center {
                                        lms_uid: uid
                                    }
                                    ... on Contentstack_course {
                                        course_id: moodle_course_number
                                        regulatory_status {
                                            promotional_or_medical
                                        }
                                    }
                                    ... on Contentstack_scientific_publication {
                                        sp_detail_id: uid
                                    }
                                    ... on Contentstack_scientific_publications {
                                        scientific_publications_uid: uid
                                    }
                                }
                            }
                            external_link {
                                link {
                                    href
                                    title
                                }
                            }
                            file_asset {
                                menu_label
                                file_asset_upload {
                                    url: transformedUrl
                                }
                            }
                            submenu {
                                menu_label
                                link {
                                    internal_page_link {
                                        internal_link_anchor_id
                                        internal_link_parameters
                                        visibility
                                        link {
                                            ... on Contentstack_page {
                                                page_url: url
                                                access_control {
                                                    access_level
                                                }
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                            }
                                            ... on Contentstack_request_materials {
                                                request_materials_uid: uid
                                            }
                                            ... on Contentstack_media_center {
                                                media_center_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_service_overview {
                                                service_overview_uid: uid
                                            }
                                            ... on Contentstack_news_center {
                                                news_center_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_ask_the_experts {
                                                ask_the_experts_uid: uid
                                            }
                                            ... on Contentstack_drug_to_drug {
                                                drug_to_drug_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_learning_center {
                                                lms_uid: uid
                                            }
                                            ... on Contentstack_transfer_of_value {
                                                transfer_of_value_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_event_center {
                                                event_center_uid: uid
                                            }
                                            ... on Contentstack_external_resource {
                                                external_resource_url: url {
                                                    href
                                                }
                                            }
                                            ... on Contentstack_material {
                                                material_id: uid
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_article {
                                                article_id: uid
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_video {
                                                video_id
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_audio {
                                                audio_id
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_event {
                                                event_id: iconnect_event_number
                                            }
                                            ... on Contentstack_pubmed {
                                                pubmed_id: id
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_product_glossary {
                                                product_glossary: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_myjmc {
                                                myjmc_id: id
                                            }
                                            ... on Contentstack_information_on_demand {
                                                iod_id: uid
                                            }
                                            ... on Contentstack_course {
                                                course_id: moodle_course_number
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                            }
                                            ... on Contentstack_scientific_publications {
                                                scientific_publications_uid: uid
                                            }
                                            ... on Contentstack_scientific_publication {
                                                sp_detail_id: uid
                                            }
                                            ... on Contentstack_pubmed {
                                                pubmed_id: id
                                                access_control {
                                                    access_level
                                                }
                                            }
                                        }
                                    }
                                    external_link {
                                        link {
                                            href
                                        }
                                    }
                                    file_asset {
                                        file_asset_upload {
                                            url: transformedUrl
                                        }
                                        visibility
                                    }
                                }
                                menu_item {
                                    internal_page_link {
                                        menu_label
                                        anchor_id
                                        link {
                                            ... on Contentstack_page {
                                                page_url: url
                                                access_control {
                                                    access_level
                                                }
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                            }
                                            ... on Contentstack_request_materials {
                                                request_materials_uid: uid
                                            }
                                            ... on Contentstack_media_center {
                                                media_center_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_service_overview {
                                                service_overview_uid: uid
                                            }
                                            ... on Contentstack_news_center {
                                                news_center_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_podcast_center {
                                                podcast_center_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_specialties {
                                                specialties_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_transfer_of_value {
                                                transfer_of_value_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_event_center {
                                                event_center_uid: uid
                                            }
                                            ... on Contentstack_external_resource {
                                                external_resource_url: url {
                                                    href
                                                }
                                            }
                                            ... on Contentstack_material {
                                                material_id: uid
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_article {
                                                article_id: uid
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_video {
                                                video_id
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_audio {
                                                audio_id
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_event {
                                                event_id: iconnect_event_number
                                            }
                                            ... on Contentstack_pubmed {
                                                pubmed_id: id
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_product_glossary {
                                                product_glossary: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_myjmc {
                                                myjmc_id: id
                                            }
                                            ... on Contentstack_information_on_demand {
                                                iod_id: uid
                                            }
                                            ... on Contentstack_ask_the_experts {
                                                ask_the_experts_uid: uid
                                            }
                                            ... on Contentstack_drug_to_drug {
                                                drug_to_drug_uid: uid
                                                access_control {
                                                    access_level
                                                }
                                            }
                                            ... on Contentstack_learning_center {
                                                lms_uid: uid
                                            }
                                            ... on Contentstack_course {
                                                course_id: moodle_course_number
                                                regulatory_status {
                                                    promotional_or_medical
                                                }
                                            }
                                            ... on Contentstack_scientific_publication {
                                                sp_detail_id: uid
                                            }
                                            ... on Contentstack_scientific_publications {
                                                scientific_publications_uid: uid
                                            }
                                        }
                                    }
                                    external_link {
                                        link {
                                            href
                                            title
                                        }
                                    }
                                    file_asset {
                                        menu_label
                                        file_asset_upload {
                                            url: transformedUrl
                                        }
                                    }
                                }
                            }
                        }
                    }
                    internal_page_link {
                        menu_label
                        anchor_id
                        link {
                            ... on Contentstack_page {
                                page_url: url
                                access_control {
                                    access_level
                                }
                                regulatory_status {
                                    promotional_or_medical
                                }
                            }
                            ... on Contentstack_request_materials {
                                request_materials_uid: uid
                            }
                            ... on Contentstack_media_center {
                                media_center_uid: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_service_overview {
                                service_overview_uid: uid
                            }
                            ... on Contentstack_news_center {
                                news_center_uid: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_podcast_center {
                                podcast_center_uid: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_specialties {
                                specialties_uid: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_transfer_of_value {
                                transfer_of_value_uid: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_event_center {
                                event_center_uid: uid
                            }
                            ... on Contentstack_external_resource {
                                external_resource_url: url {
                                    href
                                }
                            }
                            ... on Contentstack_material {
                                material_id: uid
                                regulatory_status {
                                    promotional_or_medical
                                }
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_article {
                                article_id: uid
                                regulatory_status {
                                    promotional_or_medical
                                }
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_video {
                                video_id
                                regulatory_status {
                                    promotional_or_medical
                                }
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_audio {
                                audio_id
                                regulatory_status {
                                    promotional_or_medical
                                }
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_event {
                                event_id: iconnect_event_number
                            }
                            ... on Contentstack_pubmed {
                                pubmed_id: id
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_product_glossary {
                                product_glossary: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_myjmc {
                                myjmc_id: id
                            }
                            ... on Contentstack_information_on_demand {
                                iod_id: uid
                            }
                            ... on Contentstack_ask_the_experts {
                                ask_the_experts_uid: uid
                            }
                            ... on Contentstack_drug_to_drug {
                                drug_to_drug_uid: uid
                                access_control {
                                    access_level
                                }
                            }
                            ... on Contentstack_learning_center {
                                lms_uid: uid
                            }
                            ... on Contentstack_course {
                                course_id: moodle_course_number
                                regulatory_status {
                                    promotional_or_medical
                                }
                            }
                            ... on Contentstack_scientific_publication {
                                sp_detail_id: uid
                            }
                            ... on Contentstack_scientific_publications {
                                scientific_publications_uid: uid
                            }
                        }
                    }
                    external_link {
                        link {
                            href
                            title
                        }
                    }
                    file_asset {
                        menu_label
                        file_asset_upload {
                            url: transformedUrl
                        }
                    }
                }
                smpc_reference {
                    uid
                    title
                    display_title
                    smpc_source
                    generate_detail_page
                    external_link
                    file_asset {
                        url: transformedUrl
                    }
                    page_reference {
                        ... on Contentstack_page {
                            page_url: url
                            regulatory_status {
                                promotional_or_medical
                            }
                        }
                        ... on Contentstack_material {
                            material_id: uid
                            regulatory_status {
                                promotional_or_medical
                            }
                        }
                    }
                }
            }
            fields {
                footnotes {
                    footnotes {
                        index
                        text
                    }
                    text_without_footnotes
                    text
                    mapped_text
                }
            }
            smpc_reference {
                uid
                title
                display_title
                smpc_source
                generate_detail_page
                external_link
                file_asset {
                    url: transformedUrl
                }
                page_reference {
                    ... on Contentstack_page {
                        page_url: url
                        regulatory_status {
                            promotional_or_medical
                        }
                    }
                    ... on Contentstack_material {
                        material_id: uid
                        regulatory_status {
                            promotional_or_medical
                        }
                    }
                }
            }
        }
        productGlossary: contentstackProductGlossary(locale: { eq: $locale }) {
            enable_service
        }
        specialtyService: contentstackSpecialties(locale: { eq: $locale }) {
            enable_service
        }
    }
`;
